import React from 'react';
import { Button, Container, Form, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { auth, me } from '../../store';
import PageHeading from '../PageHeading';
import { Link } from 'react-router-dom';
import {
  readPendingAddress,
  splitFullName,
} from '../../utils/pendingAddress';

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    const pending = readPendingAddress();
    const names = splitFullName(pending ? pending.fullName : undefined);
    this.state = {
      firstName: names.firstName || '',
      lastName: names.lastName || '',
      hasPendingAddress: Boolean(pending && pending.addressLine1),
      submitting: false,
    };
  }

  componentDidMount() {
    this.props.loadInitialData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error && this.props.error) {
      this.setState({ submitting: false });
    }
    if (
      prevProps.isLoggedIn !== this.props.isLoggedIn &&
      this.props.isLoggedIn
    ) {
      this.setState({ submitting: false });
    }
  }

  handleSubmit = (evt) => {
    evt.preventDefault();
    if (this.state.submitting) return;
    this.setState({ submitting: true });
    this.props.handleSubmit(evt, this.state);
  };

  render() {
    const { error } = this.props;
    const { firstName, lastName, hasPendingAddress, submitting } = this.state;

    return (
      <Container className="pad-t Center-column">
        <PageHeading icon="userPlus">Create Account</PageHeading>
        {hasPendingAddress && (
          <p className="Words signup-pending-note">
            Create an account to save your shipping address and see past orders.
          </p>
        )}
        {error && error.response && (
          <Alert variant="danger">
            {error.response.data}{' '}
            {String(error.response.data || '')
              .toLowerCase()
              .includes('already exists') && (
              <Link to="/login" className="alert-link">
                Log in
              </Link>
            )}
          </Alert>
        )}
        <Form className="Form" onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Control
              size="lg"
              type="text"
              placeholder="First Name"
              name="firstName"
              value={firstName}
              onChange={(e) => this.setState({ firstName: e.target.value })}
              required
              disabled={submitting}
            />
            <br />
            <Form.Control
              size="lg"
              type="text"
              placeholder="Last Name"
              name="lastName"
              value={lastName}
              onChange={(e) => this.setState({ lastName: e.target.value })}
              required
              disabled={submitting}
            />
            <br />
            <Form.Control
              size="lg"
              type="email"
              placeholder="Email"
              name="email"
              required
              disabled={submitting}
            />
            <br />
            <Form.Control
              size="lg"
              type="password"
              placeholder="Password"
              name="password"
              required
              disabled={submitting}
            />
          </Form.Group>
          <Button variant="info" type="submit" disabled={submitting}>
            {submitting ? 'Creating account…' : 'Sign Up'}
          </Button>
        </Form>
        <div className="Auth-links">
          <Link to={'/login'} className="Auth-link">
            Login Instead
          </Link>
          <span>·</span>
          <Link to={'/'} className="Auth-link">
            Return to Shop
          </Link>
        </div>
      </Container>
    );
  }
}

/**
 * CONTAINER
 */
const mapState = (state) => {
  return {
    error: state.user.error,
    isLoggedIn: !!state.user.id,
  };
};

const mapDispatch = (dispatch) => {
  return {
    handleSubmit(evt, formState) {
      const firstName =
        (formState && formState.firstName) || evt.target.firstName.value;
      const lastName =
        (formState && formState.lastName) || evt.target.lastName.value;
      const email = evt.target.email.value;
      const password = evt.target.password.value;
      dispatch(auth(email, password, 'signup', firstName, lastName));
    },
    loadInitialData() {
      dispatch(me());
    },
  };
};

export default connect(mapState, mapDispatch)(SignUp);

/**
 * PROP TYPES
 */
SignUp.propTypes = {
  loadInitialData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.object,
  isLoggedIn: PropTypes.bool,
};
